import { mapStyles } from '@components/MapView/MapView';
import { ImageryStatus } from '@mytypes/imagery';
import { Page } from '@mytypes/protocol';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@state-mgmt/store';

export type PreviousVisitSelection = {
  id: string;
  label: string;
  color: string;
  completedAt: string;
  selected: boolean;
};

export type VisitState = {
  changedCharacteristic: string | undefined;
  fieldBoundary: any;
  pages: Page[];
  previousVisitsSelection: PreviousVisitSelection[];
  selectedMarker: string | undefined;
  mapStyle: string | null | undefined;
  images: ImageryStatus[] | null;
  selectedImage: string | null;
  imageryEnabled: boolean;
};

const initialState: VisitState = {
  changedCharacteristic: undefined,
  fieldBoundary: undefined,
  pages: [],
  previousVisitsSelection: [],
  selectedMarker: undefined,
  mapStyle: mapStyles.satellite,
  images: null,
  selectedImage: null,
  imageryEnabled: false
};

export const visitSlice = createSlice({
  name: 'visit',
  initialState,
  reducers: {
    setFieldBoundary(state: VisitState, action: PayloadAction<any>) {
      state.fieldBoundary = action.payload;
    },
    setChangedCharacteristic(state: VisitState, action: PayloadAction<string | undefined>) {
      state.changedCharacteristic = action.payload;
    },
    setPages(state: VisitState, action: PayloadAction<Page[]>) {
      state.pages = action.payload;
    },
    setPreviousVisitsSelection(state: VisitState, action: PayloadAction<PreviousVisitSelection[]>) {
      state.previousVisitsSelection = action.payload;
    },
    setSelectedMarker(state: VisitState, action: PayloadAction<any>) {
      state.selectedMarker = action.payload;
    },
    setFieldVisitWizardMapStyle(state: VisitState, action: PayloadAction<string>) {
      state.mapStyle = action.payload;
    },
    setImagery(state: VisitState, action: PayloadAction<ImageryStatus[] | null>) {
      state.images = action.payload;
    },
    setSelectedImage(state: VisitState, action: PayloadAction<string | null>) {
      state.selectedImage = action.payload;
    },
    setImageryEnabled(state: VisitState, action: PayloadAction<boolean>) {
      state.imageryEnabled = action.payload;
    }
  }
});

// Actions
export const {
  setFieldBoundary,
  setChangedCharacteristic,
  setPages,
  setPreviousVisitsSelection,
  setSelectedMarker,
  setFieldVisitWizardMapStyle,
  setSelectedImage,
  setImagery,
  setImageryEnabled
} = visitSlice.actions;

// Selectors
export const selectFieldBoundary = (state: RootState) => state.visit.fieldBoundary;
export const selectChangedCharacteristic = (state: RootState) => state.visit.changedCharacteristic;
export const selectPages = (state: RootState) => state.visit.pages;
export const selectPreviousVisitsSelection = (state: RootState) => state.visit.previousVisitsSelection;
export const selectSelectedMarker = (state: RootState) => state.visit.selectedMarker;
export const selectFieldVisitWizardMapStyle = (state: RootState) => state.visit.mapStyle;
export const selectImagery = (state: RootState) => state.visit.images;
export const selectSelectedImage = (state: RootState) => state.visit.selectedImage;
export const selectImageryEnabled = (state: RootState) => state.visit.imageryEnabled;

export default visitSlice.reducer;
